export interface DriverStatusSummaryDto {
  offDuty: number;
  sleeperBerth: number;
  driving: number;
  onDuty: number;
  personalConveyance: number;
  yardMove: number;
}
